module.exports = __webpack_public_path__ + "img/3.573e5cc7.jpg";